/* eslint-disable react/require-default-props */
import React from 'react';
import { Box, Icon, SkeletonLoader, Typography } from '@saviynt/design-system';

import { type KpiData } from '../KpiTiles';

import './KpiTile.css';

interface KpiTileProps {
  data: KpiData | Partial<KpiData>; // Allow partial data during loading
  isLoading?: boolean;
}

function KpiTile({ data, isLoading = false }: KpiTileProps) {
  const { title, value, subtitle, /* change, */ icon } = data;

  return (
    <Box tag='article' className='Rules-KpiTile'>
      <Box tag='header' className='Rules-KpiTile-header'>
        <Typography kind='h4' className='Rules-KpiTile-title'>
          {title}
        </Typography>
        <Box className='Rules-KpiTile-iconWrapper'>
          <Icon kind={icon} className='Rules-KpiTile-icon' />
        </Box>
      </Box>
      <Box className='Rules-KpiTile-content'>
        {isLoading ? (
          <>
            {/* Skeleton for main value (taller) */}
            <SkeletonLoader
              animationStyle='wave'
              height='2rem'
              width='100%'
              className='Rules-KpiTile-valueSkeleton'
            />
            {/* Skeleton for subtitle (shorter) */}
            <SkeletonLoader
              animationStyle='wave'
              height='1.15rem'
              width='80%'
              className='Rules-KpiTile-subtitleSkeleton'
            />
          </>
        ) : (
          <>
            <Typography kind='h1' className='Rules-KpiTile-value'>
              {value}
            </Typography>
            <Typography
              kind='body2'
              color='--color-foreground-neutral-subtle'
              className='Rules-KpiTile-subtitle'>
              {subtitle}
            </Typography>
          </>
        )}
      </Box>
      {/*
      TODO: delta comes in a future mvp
      <Box className='Rules-KpiTile-deltaInfo'>
        <Typography
          kind='body3'
          className={`Rules-KpiTile-change Rules-KpiTile-change--${change.type}`}>
          {change.value}
        </Typography>
      </Box> */}
    </Box>
  );
}

export default KpiTile;
